import { Injectable } from '@angular/core';

import { LoadingController, Platform, ToastController } from '@ionic/angular';
import { FirebaseAuthentication } from '@capacitor-firebase/authentication';
import { FacebookAuthProvider , GoogleAuthProvider} from 'firebase/auth';
import { BehaviorSubject, EMPTY, from, Observable } from 'rxjs';
import { catchError, switchMap, take, tap } from 'rxjs/operators';

import { UnrSettingsService } from '../../services/settings/settings.service';
import { UnrApiService } from '../api/api.service';
import { AuthProvider } from './enum/auth-provider';
import { AuthProviderId } from './enum/auth-providers.enum';
import { AuthErrorCodes } from './enum/error-codes.enum';



// import UserCredential = firebase.auth.UserCredential;
// import EmailAuthProvider = firebase.auth.EmailAuthProvider;
import { UserRegistration } from '../api/resources/user-registration.resource';
import { Setting } from '../../services/settings/setting';
import { EmailAuthProvider, OAuthProvider, User, UserCredential } from '@angular/fire/auth';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Device } from '@capacitor/device';

import {
  SignInWithApple,
  SignInWithAppleResponse,
  SignInWithAppleOptions,
} from '@capacitor-community/apple-sign-in';
declare var hello: any;

@Injectable({ providedIn: 'root' })
export class UnrAuthService {
  rootPageChange: BehaviorSubject<any> = new BehaviorSubject<any>(undefined);
  authProvider: BehaviorSubject<AuthProvider> =
    new BehaviorSubject<AuthProvider>(undefined);

  private accessToken$: BehaviorSubject<string> = new BehaviorSubject<string>(
    ''
  );
  
  private user: User;
  private uid = '';
private loader?: HTMLIonLoadingElement;

  constructor(
    public afAuth: AngularFireAuth,
    private platform: Platform,
    private api: UnrApiService,
    private toastCtrl: ToastController,
    private loadingController: LoadingController,
    private settingsService: UnrSettingsService
  ) {}

  signOut(): Promise<void> {
    if (!this.platform.is('hybrid')) {
      return this.afAuth.signOut();
    }
    return FirebaseAuthentication.signOut();
  }

  passwordReset(email: string): Promise<void> {
    return this.afAuth.sendPasswordResetEmail(email);
  }

  async getUser(): Promise<User> {
    return await this.afAuth.currentUser;
  }

  // getUser() {
  //   return this.afAuth.currentUser;
  // }

  getAuthState(): Observable<User> {
    return this.afAuth.authState.pipe(
      tap((authState: User) => {
        this.user = authState;
        this.setUid(authState.uid);
      })
    );
  }

  setUid(id: string): void {
    this.uid = id;
  }

  getUid() {
    // return this.uid || ((await this.afAuth.currentUser).uid) ? (await this.afAuth.currentUser).uid  : "" ;
    return this.uid || localStorage.getItem('uid');
  }

  getUid2() {
    // return this.uid || ((await this.afAuth.currentUser).uid) ? (await this.afAuth.currentUser).uid  : "" ;
    return this.afAuth.currentUser;
  }

  getAccessToken(): string {
    return this.accessToken$.getValue();
  }

  register(email: string, password: string) {
    return this.afAuth.createUserWithEmailAndPassword(email, password);
  }

  // register(email: string, password: string): Promise<UserCredential> {

  //   return this.afAuth.createUserWithEmailAndPassword(email, password);
  // }



  login(
    authProvider: AuthProvider,
    email?: string,
    password?: string
  ): Observable<void> {

    this.authProvider.next(authProvider);
    return from(Device.getInfo()).pipe(
      switchMap((info) => {
        console.log(authProvider);
        if (authProvider.id === AuthProviderId.Email) {
          const credential = EmailAuthProvider.credential(email, password);
          return this.afAuth.signInWithCredential(credential);
        }
        else if (info.platform === 'web') {
          if (authProvider.id === AuthProviderId.Google) {
            console.log("WEB DESKTOP: Facebook login using popup");
            return from(this.afAuth.signInWithPopup(authProvider.firebaseProvider)).pipe(
              catchError((error: any) => {
                if (error.code === 'auth/popup-blocked' || error.code === 'auth/popup-closed-by-user') {
                  console.log("Popup blocked → using redirect");
                  this.afAuth.signInWithRedirect(authProvider.firebaseProvider).catch(err =>
                    console.error('Redirect sign-in error:', err)
                  );
                  return EMPTY;
                }
                throw error;
              })
            );
          }
          else if (authProvider.id === AuthProviderId.Facebook) {
            const isMobileBrowser = /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);

            if (info.platform === 'web' && !isMobileBrowser) {
              // Desktop web
              console.log("WEB DESKTOP: Facebook login using popup");
              return from(this.afAuth.signInWithPopup(authProvider.firebaseProvider)).pipe(
                catchError((error: any) => {
                  if (error.code === 'auth/popup-blocked' || error.code === 'auth/popup-closed-by-user') {
                    console.log("Popup blocked → using redirect");
                    this.afAuth.signInWithRedirect(authProvider.firebaseProvider).catch(err =>
                      console.error('Redirect sign-in error:', err)
                    );
                    return EMPTY;
                  }
                  throw error;
                })
              );
            } else {
              // Mobile web browser OR mobile app → native plugin
              console.log("MOBILE (browser)");
               return from(this.loginWithFacebook());
              // return from(
              //   this.afAuth.setPersistence('local').then(() => {
              //     return this.afAuth.signInWithPopup(authProvider.firebaseProvider);
              //   })
              // ).pipe(
              //   catchError((error: any) => {
              //     throw error;
              //   })
              // );
            }

          }


        }
        else if (authProvider.id === AuthProviderId.Apple) {
          return SignInWithApple.authorize().then((response: any) => {
            console.log(response);
            const credential = new OAuthProvider('apple.com').credential(
              response.response.identityToken
            );
            return this.afAuth.signInWithCredential(credential);
          });
        } else {
          switch (authProvider.id) {
            case AuthProviderId.Google:
              return from(FirebaseAuthentication.signInWithGoogle()).pipe(
                switchMap(async (result: any) => {
                  console.log('Google sign-in result:', result);
                  // For Capacitor Firebase Auth, token is under result.credential.idToken
                  const idToken = result?.credential?.idToken || result?.user?.idToken;
                  if (!idToken) throw new Error('No Google ID token returned');
                  const credential = GoogleAuthProvider.credential(idToken);
                  return this.afAuth.signInWithCredential(credential).then((cred) => {
                    console.log('Firebase sign-in complete:', cred.user?.email, cred.user?.uid);
                    return cred;
                  });
                })
              );

            case AuthProviderId.Facebook:
              return from(FirebaseAuthentication.signInWithFacebook()).pipe(
                switchMap(async (result: any) => {
                  console.log('Facebook sign-in result:', result);
                  // Access token is sometimes at result.credential.accessToken or result.result.credential.accessToken
                  const accessToken =
                    result?.credential?.accessToken || result?.result?.credential?.accessToken;
                  if (!accessToken) throw new Error('No Facebook access token returned');
                  const credential = FacebookAuthProvider.credential(accessToken);
                  return this.afAuth.signInWithCredential(credential).then((cred) => {
                    console.log('Firebase sign-in complete:', cred.user?.email, cred.user?.uid);
                    return cred;
                  });
                })
              );

            // … other providers …
            default:
              throw new Error('Unsupported provider: ' + authProvider.id);
          }

        }
      }),
      switchMap(() => {
        return from(this.setupPostLogin());
      })
    );
  }

loginWithFacebook(): Promise<any> {
  localStorage.setItem('fbloginst','yes');
  return hello('facebook').login({
    scope: 'email',
    display: 'page', // 👈 forces redirect explicitly
    auth_type: 'reauthenticate'
  });
}




  setupPostLogin(): Promise<void> {
    return Promise.resolve(this.afAuth.currentUser)
      .then((user) => {
        this.user = user;
        this.uid = user.uid;
      })
      .then(async () => (await this.afAuth.currentUser).getIdTokenResult(true))
      .then((token) => this.accessToken$.next(token.token))
      .then(async () => {
        const email = (await this.afAuth.currentUser).email;
        if (email === undefined || email === null) {
          return (await this.afAuth.currentUser).providerData[0].email;
        }
        return email;
      })
      .then((email) => this.api.registerUser(email).pipe(take(1)).toPromise())
      .then((userRegistration: UserRegistration) => {
        const settings: Array<Setting> = userRegistration.settings;
        if (userRegistration.settings) {
          this.settingsService.setAllSettings(settings);
        }
      })
      .catch(async (err) => {
        console.log(err);
        const toast: HTMLIonToastElement = await this.toastCtrl.create({
          message: 'Login failed',
          duration: 5000,
          buttons: [
            {
              text: 'Close',
              role: 'cancel',
            },
          ],
        });
        await toast.present();

        this.loadingController.dismiss();
      });
  }

 

  private accountExists(error: any): boolean {
    return (
      error.code === AuthErrorCodes.FacebookAccountExistsCode ||
      error.message === AuthErrorCodes.TwitterAccountExistsMessage
    );
  }

async showLoadingIndicator(): Promise<void> {
  if (this.loader) {
    return; // already showing
  }

  this.loader = await this.loadingController.create({
    message: 'Hold on to your steering wheel...',
    backdropDismiss: true
  });

  await this.loader.present();
}
async hideLoadingIndicator(): Promise<void> {
  try {
    const top = await this.loadingController.getTop();
    if (top) {
      await top.dismiss();
    }
  } catch {}
}


}
